/* eslint-disable arrow-body-style */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Node } from "@iventis/domain-model/model/node";
import { TreeAction, useTreeBrowser } from "@iventis/tree-browser";
import { findNodes } from "@iventis/tree-browser/tree-operations";
import React, { FunctionComponent, useState } from "react";
import { TreeBrowserDomainNodeContext } from "@iventis/tree-browser/implementations/library/helpers/library.helpers";
import { DeleteNodesConfirmationComponent } from "./delete-nodes-confirmation";

const DeleteNodeWrapperComponent: FunctionComponent<{
    nodes?: Node[];
    text: string;
    disabled?: boolean;
    onDelete?: (nodes?: Node[]) => void;
}> = ({ nodes, text, disabled, onDelete }) => {
    const [{ tree, selectedNodeIds }] = useTreeBrowser(TreeBrowserDomainNodeContext, null, "tree", "selectedNodeIds");

    const [modalOpen, setModalOpen] = useState(false);

    const handleModalClose = () => setModalOpen(false);
    const [nodesToDelete, setNodesToDelete] = useState<Node[]>();

    const openDeleteModal = () => {
        setNodesToDelete(nodes || findNodes([tree], selectedNodeIds));
        setModalOpen(true);
    };

    return (
        <>
            <DeleteNodesConfirmationComponent
                nodes={nodesToDelete}
                show={modalOpen}
                onClose={(nodes) => {
                    handleModalClose();
                    onDelete(nodes);
                }}
                modalLocation="library"
            />
            <TreeAction
                text={text}
                disabled={disabled}
                onClick={(e) => {
                    e.stopPropagation();
                    openDeleteModal();
                }}
                dataCy="delete-nodes"
            >
                <FontAwesomeIcon size="xs" icon={{ prefix: "far", iconName: "trash" }} />
            </TreeAction>
        </>
    );
};

export default DeleteNodeWrapperComponent;
